import { gql } from '@apollo/client';

export const DELETE_INSPECTION = gql`
  mutation DeleteInspection($regionId: String!, $inspectionId: String!) {
    deleteInspection(regionId: $regionId, inspectionId: $inspectionId)
  }
`;
